module.exports = __webpack_public_path__ + "assets/img/0613.f3e554b7.svg";